import React from "react";
import { RouterProvider } from "react-router-dom";
import { router } from "../routes";

function Router() {
  return <RouterProvider router={router()} />;
}

export default Router;
